import { logger } from 'lib/logger';
import { path } from 'ramda';
import { IS_BLOCKED, IS_FREE_BIZ_SAAS_USER } from 'reactApp/appHelpers/configHelpers';
import { getFolderPath } from 'reactApp/modules/file/utils';
import { accessControlListLoadStart } from 'reactApp/modules/folderAccessControlList/folderAccessControlList.actions';
import { loadFolderFail, loadFolderStart, loadFolderSuccess } from 'reactApp/modules/home/home.actions';
import { getHomeItemById } from 'reactApp/modules/home/home.selectors';
import type { ApiFolderResponse } from 'reactApp/modules/home/home.types';
import { checkFolderForUpdate } from 'reactApp/modules/modifying/modifying.actions';
import { updatePublicInfoDownloadLimits } from 'reactApp/modules/public/public.actions';
import { waitForSortInitialized } from 'reactApp/modules/sort/sort.helpers';
import { getSortById } from 'reactApp/modules/sort/sort.selectors';
import { getPrivateList } from 'reactApp/modules/start/start.saga';
import { isDomainFolder } from 'reactApp/modules/storage/folder.helpers';
import { getLoadMoreLimit } from 'reactApp/modules/storage/storage.helpers';
import { getItemById } from 'reactApp/modules/storage/storage.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { call, cancel, put, select } from 'redux-saga/effects';

/* eslint-disable complexity */
export function* loadHomeFolder(payload) {
    if (IS_BLOCKED) {
        return;
    }

    let { id } = payload;
    const { isFolder, force } = payload;

    try {
        id = decodeURIComponent(id); // при переходе в папку в названии которой есть #, будет ошибка, поэтому игнорируем её и обрабатываем отдельно
    } catch (error) {
        logger.error(error);
    }

    const item = yield select(getHomeItemById, id);

    if ((item?.isLoaded || item?.isLoading) && !force) {
        yield put(checkFolderForUpdate(id));
        if (IS_FREE_BIZ_SAAS_USER && item?.isMounted && !item?.isReadOnly && !isDomainFolder(item)) {
            const mountedRootFolderId = item?.id.split('/').slice(0, 2).join('/');
            const mountedRootFolder = yield select(getItemById, mountedRootFolderId);
            if (!isDomainFolder(mountedRootFolder)) {
                yield put(accessControlListLoadStart({ id: mountedRootFolderId || '', storage: item?.storage }));
            }
        }
        return;
    }

    try {
        const path = item?.isFolder ? item.id : getFolderPath(id, isFolder);

        yield put(loadFolderStart(payload));

        if (item?.count?.all > 500) {
            yield waitForSortInitialized();
        }

        const sort = yield select((state) => getSortById(state, path));

        const data: ApiFolderResponse = yield call(getPrivateList, path, getLoadMoreLimit(EStorageType.home), 0, sort);

        const weblinkList = data?.list || [];
        for (const itemList of weblinkList) {
            const download_limit = itemList.public?.download_limit;
            const public_id = itemList.public?.id || '';
            if (download_limit) {
                yield put(updatePublicInfoDownloadLimits({ download_limit, public_id }));
            }
        }

        if (data.home.toLowerCase() === id.toLowerCase()) {
            data.home = id;
        }
        yield put(loadFolderSuccess(data));
    } catch (error) {
        logger.error(error);
        let message = 'Load folder api error';
        if (error instanceof Error) {
            // TODO: use ErrorPage.helpers.getText
            message = (path(['status'], error) as any)?.toString();
        }
        yield put(loadFolderFail({ id: payload.id, error: message }));
        yield cancel();
    }
}
